import * as React from "react";
import {Footer} from '../../component/layout/Footer';
import {Navigation} from '../../component/layout/Navigation';

export class CitizenReportSuccess extends React.Component {

    public render() {
        return (
            <div id="citizen-report-page" className="page client-area">
                <Navigation navClass="main-nav js-stick" />

                <section className="page-section bg-dark-alfa-30 parallax-3 dusun-header-section">
                    <div className="relative container align-left">
                        <div className="row">
                            <div className="col-md-8">
                                <h1 className="hs-line-11 font-alt mb-20 mb-xs-0">Terima Kasih!</h1>
                                <div className="hs-line-4 font-alt black">Sistem Informasi Aspirasi & Pengaduan masyarakat</div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="page-section">
                    <div className="container relative">

                        <h5>Laporan Anda telah kami terima, Kami akan memproses secepatnya dan akan memberitahukan hasilnya di menu <b>Pengumuman</b></h5>

                    </div>
                </section>

                <Footer />
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/screen/society-report/CitizenReportSuccess.tsx